import { TimeoutModalHandler } from "components/TimeoutModal/TimeoutModal";
import { useProfile } from "library/hooks/auth/useProfile";
import { validateTnCString } from "library/validator";
import { useEffect } from "react";
import { Navigate, Route, useLocation, useNavigate } from "react-router-dom";
import { Layout } from "../layout";
import { DisabledByFeatureFlag } from "./DisabledByFeatureFlag";

interface AuthProps {
  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.FC<any> | null;
  noStateRedirect?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
  featureFlag?: boolean;
}

export const AuthRoute = ({
  path,
  component: Component,
  noStateRedirect,
  featureFlag,
  ...rest
}: AuthProps) => {
  const { profile, isLoggedIn } = useProfile();
  const location = useLocation();
  const navigate = useNavigate();
  const shouldRedirect = !location.state && noStateRedirect;

  useEffect(() => {
    if (!location.state && isLoggedIn && noStateRedirect) {
      navigate(noStateRedirect);
    }
  }, [isLoggedIn, location.state, navigate, noStateRedirect, shouldRedirect]);

  if (!isLoggedIn) {
    return (
      <Navigate
        to={shouldRedirect && noStateRedirect ? noStateRedirect : "/login"}
        state={{ referer: location }}
      />
    );
  }

  if (isLoggedIn && profile?.id && !validateTnCString(profile?.id)) {
    return <Navigate to="/terms" state={{ referer: location }} />;
  }

  if (!Component) {
    return null;
  }

  if (featureFlag === false) {
    // 🦘 We are interested only when FF is specifically set to false.
    return (
      <Layout>
        <DisabledByFeatureFlag />
      </Layout>
    );
  }

  return (
    <Route
      path={path}
      element={
        <>
          <Layout>
            <Component
              path={path || ""}
              location={location}
              isLoggedIn={isLoggedIn}
              {...rest}
            />
          </Layout>
          <TimeoutModalHandler />
        </>
      }
    />
  );
};
